import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { IField } from "../../types/api";
import { Col, Row, Table } from "react-bootstrap";
import { useAppSelector } from "../../hooks/reduxHooks";
import { store } from "../..";
import { globalActions, selectFields } from "../../features/global/globalSlice";

export const loader = async () => {
    const fields = store.getState().global.fields;

    const fieldPromise = fields.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getFields());

    await Promise.all([fieldPromise]);

    return null;
};

const TemplatesIndex = (): React.JSX.Element | undefined => {
    const loadedFields = useAppSelector(selectFields);
    const [fields, setFields] = useState<IField[]>(loadedFields);
    const location = useLocation();

    useEffect(() => {
        setFields(loadedFields);
    }, [loadedFields, setFields]);

    const isOnTemplateListPage = /templates\/?$/.test(location.pathname);

    return isOnTemplateListPage ? (
        <Row>
            <Col
                className="templateListContent"
                data-testid="templateListContent"
                xs={{ span: 10 }}
            >
                <h2>Template List</h2>
                <Table striped borderless>
                    <thead>
                        <tr>
                            <th>Field Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {fields.map(f => (
                            <tr key={f.id}>
                                <td>{f.name}</td>
                                <td>
                                    <Link to={`edit/${f.id}`}>edit</Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>
    ) : (
        <Outlet />
    );
};

export default TemplatesIndex;
